import React, {useEffect, useState} from 'react';
import {connect} from "react-redux";
import {withRouter} from "../../../../utils/services/with-router";
import {Flex, Skeleton} from "antd";
import ProductListHeader from "../../components/productListHeader/ProductListHeader";
import AdsBanner from "../../../../shared/components/adsBanner/AdsBanner";
import ProductCard from "../../../../shared/components/productCard/ProductCard";
import {ProductListFilterModel, ProductListProps} from "../../models";
import {getProductList, getUserProductList} from "../../actions/Product.action";
import {useLocation} from "react-router-dom";
import ProvinceCard from "../../../../shared/components/location/provinceCard/ProvinceCard";
import CitiesCard from "../../../../shared/components/location/citiesCard/CitiesCard";
import {EmptyMessage} from "../../../../shared";
import UserProductListHeader from "../../components/userProductListHeader/UserProductListHeader";

const UserProductList = (props: any) => {
    const [products, setProducts] =
        useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const location = useLocation()
    const getList = () => {
        setLoading(true)
        let model:ProductListFilterModel ={
            fromIndex:'',
            fromPrice:'',
            toIndex:'',
            toPrice:'',
            searchText:'',
            subCategoryId:'',
        }
        props.getUserProductList(model)
            .then((data: any) => {
                if (data.payload != undefined) {

                    setProducts(data.payload.data);

                    setLoading(false);
                } else {
                    setLoading(false);
                }
            })
            .catch((e: any) => {
            });
    };
    useEffect(() => {
        getList();
    }, []);
    return (
        <Flex vertical gap={"small"}>
            <UserProductListHeader />
            <AdsBanner/>
            {(products?.length === 0 && !loading) && <EmptyMessage message={"آگهی در حال حاضر موجود نیست !"}/>}
            {loading ?<Flex vertical >
                    <Skeleton round active/>
                    <Skeleton round active/>
                    <Skeleton round active/>
                </Flex> :
                products.map((item:any) => <ProductCard isOwner={true} product={item}/>)
            }


        </Flex>
    );
};

export default connect(null, {getUserProductList})(withRouter(UserProductList));
